import { MButton } from '@assets/mui/@material-extend';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CargoSpecialConditionalStyledContainer from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/сargoSpecialConditional/StyledComponents';
import CargoSpecialConditionalProps from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/сargoSpecialConditional/types';
import { isEqualsForMemo } from '@settings/services/types';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useDelivery from '../../../useDelivery';

const isEquals: isEqualsForMemo<CargoSpecialConditionalProps> = (prevProps, nextProps) =>
  JSON.stringify([prevProps.isDangerousCargo]) === JSON.stringify([nextProps.isDangerousCargo]);

/**
 * Компонент включения и конфигурации особых условий транспортировки
 * @param props
 */
const CargoSpecialConditional = (props: CargoSpecialConditionalProps) => {
  const { isDangerousCargo } = props;

  const { useIsRoutesLoading, useIsLoading, useRouteParams } = useDelivery();
  const [isRoutesLoading] = useIsRoutesLoading().useState();
  const [isLoading] = useIsLoading().useState();
  const [_, setRouteParameter] = useRouteParams().useState();

  const [isExpanded, setIsExpanded] = useState<boolean>(() => isDangerousCargo);

  const { t } = useTranslation('DeliveryForm');

  const ExpandIcon = isExpanded ? ExpandLessIcon : ExpandMoreIcon;

  const toggleAccordionExpandHandler = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const changeRouteParamsHandler = (value: boolean) => {
    setRouteParameter((prevState) => {
      const paramKey =
        prevState.cargoType === 'container' ? 'containerParameters' : 'customCargoParameters';

      return {
        ...prevState,
        [paramKey]: {
          ...prevState[paramKey],
          isDangerousCargo: value,
        },
      };
    });
  };

  return (
    <CargoSpecialConditionalStyledContainer>
      <div className="base-params__wrap">
        <div>
          <MButton
            variant={'outlined'}
            color={'inherit'}
            fullWidth={true}
            style={{
              backgroundColor: isDangerousCargo ? '#E9FCD4' : 'inherit',
            }}
            endIcon={<ExpandIcon fontSize="medium" sx={{ color: '#383838' }} />}
            onClick={toggleAccordionExpandHandler}
          >
            {t('DeliveryForm:SpecialConditions')}
          </MButton>
        </div>

        {isExpanded && (
          <div className="base-params__items">
            <FormControlLabel
              className="base-params__item"
              label={t('DeliveryForm:DangerousGoods')}
              control={
                <Checkbox
                  size={'medium'}
                  checked={isDangerousCargo}
                  disabled={isRoutesLoading || isLoading}
                  onChange={() => changeRouteParamsHandler(!isDangerousCargo)}
                />
              }
            />
          </div>
        )}
      </div>
    </CargoSpecialConditionalStyledContainer>
  );
};

export default memo(CargoSpecialConditional, isEquals);
